var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../../../../api/agency.service';
import { MatDialogRef } from '@angular/material';
import { LocaleAwareBaseComponent } from './../../../../seo/locale-aware-base.component';
var ShowContactFormModalBaseComponent = /** @class */ (function (_super) {
    __extends(ShowContactFormModalBaseComponent, _super);
    function ShowContactFormModalBaseComponent(agencyService, dialogRef, document) {
        var _this = _super.call(this) || this;
        _this.agencyService = agencyService;
        _this.dialogRef = dialogRef;
        _this.document = document;
        dialogRef.afterClosed().subscribe(function (result) {
            _this.document.body.classList.remove('no-scroll');
        });
        return _this;
    }
    return ShowContactFormModalBaseComponent;
}(LocaleAwareBaseComponent));
export { ShowContactFormModalBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-contact-form-modal-base/show-contact-form-modal-base.component.ts.pre-build-optimizer.js